import { t } from '@lingui/core/macro';
import { Button, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { keyExtractor } from 'shared/domains/common-utils';
import { useTasks } from '../TasksProvider/useTasks';
import { SortIds } from '../types';
import { StyledButtonContent, StyledMenuContainer } from './styled';
export function SortSelector() {
    const { sortBy, setSortBy } = useTasks();
    const sortOptions = Object.freeze({
        [SortIds.createdAt]: {
            asc: t({
                comment: 'Option text to sort tasks by created at date oldest first',
                message: 'Created (oldest)',
            }),
            desc: t({
                comment: 'Option text to sort tasks by created at date newest first',
                message: 'Created (newest)',
            }),
        },
        [SortIds.updatedAt]: {
            asc: t({
                comment: 'Option text to sort tasks by updated on date oldest first',
                message: 'Updated (oldest)',
            }),
            desc: t({
                comment: 'Option text to sort tasks by updated on date newest first',
                message: 'Updated (newest)',
            }),
        },
        [SortIds.dueDate]: {
            asc: t({
                comment: 'Option text to sort tasks by due date oldest first',
                message: 'Due date (oldest)',
            }),
            desc: t({
                comment: 'Option text to sort tasks by due date newest first',
                message: 'Due date (newest)',
            }),
        },
        [SortIds.title]: {
            asc: t({
                comment: 'Option text to sort tasks by title alphabetically',
                message: 'Title (A-Z)',
            }),
            desc: t({
                comment: 'Option text to sort tasks by title reverse alphabetically',
                message: 'Title (Z-A)',
            }),
        },
        [SortIds.status]: {
            asc: t({
                comment: 'Option text to sort tasks by status alphabetically',
                message: 'Status (A-Z)',
            }),
            desc: t({
                comment: 'Option text to sort tasks by status reverse alphabetically',
                message: 'Status (Z-A)',
            }),
        },
    });
    const currentSort = sortOptions[sortBy.sortId];
    const sortIds = keyExtractor(sortOptions);
    // NOTE: remove when status is available in task widget
    const filteredSortIds = sortIds.filter((id) => id !== SortIds.status);
    const flattenedSortOptions = filteredSortIds.flatMap((id) => {
        const value = sortOptions[id];
        const sortOrders = keyExtractor(value);
        return sortOrders.map((sortOrder) => {
            const selected = sortBy.sortId === id && sortBy.sortOrder === sortOrder;
            return { sortId: id, sortOrder, text: value[sortOrder], selected };
        });
    });
    return (<StyledMenuContainer>
      <Menu.Root target={<Button appearance="secondary" size="small" $stretch>
            <StyledButtonContent>
              <Falcon icon="filter-list" $size={16}/>
              {currentSort[sortBy.sortOrder]}
            </StyledButtonContent>
          </Button>}>
        {flattenedSortOptions.map(({ sortId, sortOrder, text, selected }) => (<Menu.ItemRadio key={`${sortId}-${sortOrder}`} checked={selected} onChange={() => setSortBy({ sortId, sortOrder })}>
            {text}
          </Menu.ItemRadio>))}
      </Menu.Root>
    </StyledMenuContainer>);
}
